import React from "react";
import PropTypes from "prop-types";
import { SnackMsg, Label16, Chips, Label14, Label28 } from "../../components";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import ReportAGgrid from "../ReportsAGgrid";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { API_URL, ADMIN_TYPE } from "../../utils/Constants";
import { ApiService } from "../../utils/ApiService";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import {
  getFrequency,
  getNotifictionDateFormat,
  getLoggedInRole,
  getMerchantId,
} from "../../utils/Helper";
import { Typography } from "@mui/material";

class ReportsHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      studentValueList: [],
      studentValueListCopy: [],
      SyncDataCss: "SyncData",

      snackMsg: "",
      showSnack: false,
      loader: true,
      pageNo: 0,
      pageSize: 10,
      tabSelectvalue: 0,
      showHistory: false,
      HistoryDetails: "",
      tabSelection: this.props.tabSelection,
      isDeleted: false,
      TotalCount: "",
      isTemplateFound: "",
      isDeleteCustomReport: false,
      isDelete: false,
      DeleteReportName: "",
      InstructionId: "",
    };
  }

  static propTypes = {
    onShowTabs: PropTypes.func.isRequired,
    onHideTabs: PropTypes.func.isRequired,
    tabSelection: PropTypes.string,
  };

  componentDidMount() {
    this.refreshHistoryList();
  }

  async refreshHistoryList() {
    let requestPayload = {
      merchantId:
        this.state.tabSelection === "MainLanding" ? "-1" : getMerchantId(),
      reportCategory: "STANDARD",
    };

    const url =
      API_URL.REPORT_SCHEDULED_READ +
      "?offset=" +
      this.state.pageNo +
      "&limit=" +
      this.state.pageSize;

    const resp = await ApiService.postRequest(url, requestPayload);
    if (resp?.status?.code === "Y") {
      this.setState({ studentValueList: resp.body });
      this.setState({ studentValueListCopy: resp.body });
      this.setState({ SyncDataCss: "SyncData" });
      this.setState({ loader: false });

      this.setState({ isTemplateFound: true });
      this.setState({ TotalCount: parseInt(resp.status.message) });
    } else {
      this.setState({ isTemplateFound: false });
    }
  }

  //****************************************************************** */
  //****************************************************************** */
  // Handlers ...

  onDelete = async (params) => {
    this.setState({ isDeleteCustomReport: true });
    this.setState({ DeleteReportName: params.data.type });
    this.setState({ InstructionId: params.data.scheduledReportId });
  };

  OnDeleteSchedule = async () => {
    const url = API_URL.DELETE_SCHEDULED_HISTORY + this.state.InstructionId;
    const response = await ApiService.deleteRequest(url);
    if (
      (response.error != undefined && response.error.status_code === 401) ||
      response.status === "403"
    ) {
      this.setState({
        isDeleted: false,
        snackMsg: response.status.message,
        showSnack: true,
        showHistory: false,
      });
      return;
    }
    if (response.status.code == "Y") {
      this.setState(
        {
          isDeleted: true,
          snackMsg: response.status.message,
          showSnack: true,
          showHistory: false,
        },
        this.props.onShowTabs
      );
      this.refreshHistoryList();
      this.onHideCustomModal();
    }
  };

  //-----------------------------------------------------------------------------------------
  onHideCustomModal = () => {
    this.setState({ isDeleteCustomReport: false, isDelete: false });
  };

  backButton = () => {
    this.setState({ showHistory: false }, this.props.onShowTabs);
  };
  onCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnack: false });
  };
  onShowHistory = (params) => {
    this.setState({ HistoryDetails: params.data });
    this.setState({ showHistory: true }, this.props.onHideTabs);
  };
  displayScheduledDate = () => {
    let date = getNotifictionDateFormat(
      this.state.HistoryDetails.nextScheduledDate
    );
    return <Label14>{date}</Label14>;
  };
  //****************************************************************** */
  //****************************************************************** */
  // Render methods ...
  onPageSizeChanged = (event) => {
    this.setState({ pageSize: event.target.value }, this.refreshHistoryList);
    this.setState({ loader: true });
  };

  onLeftArrow = () => {
    this.setState({ pageNo: this.state.pageNo - 1 }, this.refreshHistoryList);
    this.setState({ loader: true });
  };

  onRightArrow = () => {
    this.setState({ pageNo: this.state.pageNo + 1 }, this.refreshHistoryList);
    this.setState({ loader: true });
  };

  renderLeftBtn() {
    const isDisabled = this.state.TotalCount == 0 || this.state.pageNo == 0;
    const iconCss = isDisabled
      ? "notificationLeftArrowDisabled"
      : "notificationLeftArrow";
    return (
      <button
        style={{ border: "none", background: "none" }}
        className={iconCss}
        onClick={isDisabled ? null : this.onLeftArrow}
      />
    );
  }

  renderRightBtn() {
    let toNo = this.state.pageNo * this.state.pageSize + this.state.pageSize;
    if (toNo > this.state.TotalCount) toNo = this.state.TotalCount;
    const isDisabled =
      this.state.TotalCount == 0 || toNo == this.state.TotalCount;
    const iconCss = isDisabled
      ? "notificationRightArrowDisabled"
      : "notificationRightArrow";
    return (
      <button
        style={{ border: "none", background: "none" }}
        className={iconCss}
        onClick={isDisabled ? null : this.onRightArrow}
      />
    );
  }

  tableHeader() {
    return (
      <div className="p-4">
        <Typography variant="h5">Your scheduled reports</Typography>
      </div>
    );
  }

  tablefooter() {
    const fromNo = this.state.pageNo * this.state.pageSize + 1;
    let toNo = this.state.pageNo * this.state.pageSize + this.state.pageSize;
    if (toNo > this.state.TotalCount) toNo = this.state.TotalCount;
    return (
      <div
        className="divRow"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          padding: 14,
        }}
      >
        <FormControl variant="outlined" className="formControlCss">
          <InputLabel id="demo-simple-select-outlined-label">Age</InputLabel>
          <Select value={this.state.pageSize} onChange={this.onPageSizeChanged}>
            <MenuItem value={10}>10 Items</MenuItem>
            <MenuItem value={20}>20 Items</MenuItem>
            <MenuItem value={30}>30 Items</MenuItem>
          </Select>
        </FormControl>
        {/*........for Pagination........*/}
        <div className="divRow" style={{ alignItems: "center" }}>
          {this.state.TotalCount > 0 && (
            <label className="label12" style={{ color: "#6d758e", margin: 0 }}>
              Showing {fromNo} - {toNo} of {this.state.TotalCount}
            </label>
          )}
          <div style={{ width: 16 }} />
          {this.renderLeftBtn()}
          <div style={{ width: 8 }} />
          {this.renderRightBtn()}
        </div>
      </div>
    );
  }
  renderCustomReports = () => {
    return (
      <div>
        <div className="ReportsAGgridContainer">
          {this.state.loader ? (
            this.loader()
          ) : (
            <div style={{ paddingBottom: 24 }}>
              {this.tableHeader()}
              <ReportAGgrid
                studentDetails={this.state.studentValueList}
                {...this.props}
                onShowHistory={(e) => this.onShowHistory(e)}
                onDelete={(e) => this.onDelete(e)}
              />
              <div className="TableFooter">
                <div>{this.tablefooter()}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  loader() {
    return (
      <div>
        {this.state.loader ? (
          <div style={{ margin: 20 }}>
            <div style={{ display: "flex" }}>
              <Skeleton
                animation="wave"
                variant="text"
                width={200}
                height={100}
              />
              <div style={{ width: "80%" }}></div>
              <Skeleton
                animation="wave"
                variant="text"
                width={100}
                height={100}
              />
            </div>
            <div style={{ height: 10 }}></div>
            <Skeleton
              animation="wave"
              variant="text"
              width="100%"
              height={100}
            />
            <Skeleton
              animation="wave"
              variant="text"
              width="100%"
              height={100}
            />
            <Skeleton
              animation="wave"
              variant="text"
              width="100%"
              height={100}
            />

            <div style={{ display: "flex" }}>
              <Skeleton
                animation="wave"
                variant="text"
                width={200}
                height={100}
              />
              <div style={{ width: "80%" }}></div>
              <Skeleton
                animation="wave"
                variant="text"
                width={100}
                height={100}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
  renderHistoryDetails() {
    return (
      <div>
        <div
          className="divRow"
          style={{ alignItems: "center", marginTop: -90 }}
        >
          <button
            className="backIcon"
            style={{
              cursor: "pointer",
              border: "none",
            }}
            onClick={this.backButton}
          />
          <Label28 bold>Schedule Report Details</Label28>
        </div>
        <div
          style={{
            color: "#6d758e",
            fontSize: 12,
            fontFamily: "Open Sans",
            opacity: "70%",
            display: "Block",
            paddingLeft: 50,
          }}
        >
          Reports &gt; Existing Schedules &gt;
          {this.state.HistoryDetails.reportName}
          <div
            style={{
              marginTop: -20,
              paddingLeft: "90%",
              paddingRight: 24,
              float: "right",
            }}
          >
            <Button
              className="allTypeBtn"
              style={{ fontSize: 14, color: "#402ca8" }}
              disabled={
                getLoggedInRole() === ADMIN_TYPE.SALESADMIN ||
                getLoggedInRole() === ADMIN_TYPE.SCHOOLADMIN
              }
              onClick={() =>
                this.setState({
                  isDeleteCustomReport: true,
                  DeleteReportName: this.state.HistoryDetails.reportName,
                  InstructionId: this.state.HistoryDetails.scheduledReportId,
                })
              }
            >
              Delete
            </Button>
            {/* )} */}
          </div>
        </div>

        <div className="ScheduleHistoryDetails">
          <div style={{ display: "Block", width: "50%" }}>
            <Label16 bold>Schedule Report Details</Label16>
            <div style={{ height: 24 }}></div>
            {this.state.HistoryDetails.reportExecutionStatus === "Failed" ? (
              <div
                style={{
                  color: "#FF0000",
                  fontSize: 12,
                  fontFamily: "Open Sans",
                  display: "flex",
                  marginBottom: 16,
                }}
              >
                <div className="errorIcon"></div>
                Delivery failed due to system error. Please contact admin.
              </div>
            ) : null}
            <div style={{ display: "flex" }}>
              <div
                style={{
                  display: "Block",
                  width: "50%",
                  marginBottom: 24,
                  wordBreak: "break-word",
                  paddingRight: 24,
                }}
              >
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                    display: "Block",
                    wordBreak: "break-word",
                    paddingRight: 24,
                  }}
                >
                  Schedule Name
                </div>
                <Label14>{this.state.HistoryDetails.reportName}</Label14>
              </div>
              <div style={{ display: "Block" }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                    display: "Block",
                  }}
                >
                  Delivery Status
                </div>
                <Label14>
                  {this.state.HistoryDetails.reportExecutionStatus}
                </Label14>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "Block", width: "50%", marginBottom: 24 }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                    display: "Block",
                  }}
                >
                  Report Name
                </div>
                <Label14>{this.state.HistoryDetails.type}</Label14>
              </div>
              <div style={{ display: "Block", width: "50%", marginBottom: 24 }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                    display: "Block",
                  }}
                >
                  Report Type
                </div>
                <Label14>{this.state.HistoryDetails.reportCategory}</Label14>
              </div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "Block", width: "50%", marginBottom: 24 }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                    display: "Block",
                  }}
                >
                  Scheduled On
                </div>
                {this.displayScheduledDate()}
              </div>
            </div>
          </div>
          <div style={{ display: "Block", width: "50%" }}>
            <Label16 bold>Schedule Frequency</Label16>
            <div style={{ height: 24 }}></div>
            <div style={{ display: "flex" }}>
              <div style={{ display: "Block", width: "50%", marginBottom: 24 }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                    display: "Block",
                  }}
                >
                  Frequency
                </div>
                <Label14>
                  {getFrequency(this.state.HistoryDetails.frequency)}
                </Label14>
              </div>
              {this.state.HistoryDetails.frequency === "D" ? null : (
                <div style={{ display: "Block" }}>
                  <div
                    style={{
                      color: "#6d758e",
                      fontSize: 12,
                      fontFamily: "Open Sans",
                      opacity: "70%",
                      display: "Block",
                    }}
                  >
                    Day
                  </div>
                  <Label14>
                    {this.state.HistoryDetails.scheduledIntervalPeriod}
                  </Label14>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            color: "#6d758e",
            fontSize: 12,
            fontFamily: "Open Sans",
            opacity: "70%",
            display: "Block",
            marginLeft: 24,
          }}
        >
          Email Address
        </div>
        <Grid
          container
          style={{
            display: "flexGrow",
            margin: 24,
            marginTop: 10,
            width: "auto",
          }}
          spacing={1}
        >
          {this.state.HistoryDetails.emailList.map((item) => (
            <Grid item key={item}>
              <Chips className="Columns_Chips" disabled label={item} />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  }
  renderDeleteCustomView() {
    return (
      <Modal
        className="popUpModal"
        show={this.state.isDeleteCustomReport}
        onHide={this.onHideCustomModal}
      >
        <Modal.Header style={{ borderBottomWidth: 0 }} closeButton>
          <Modal.Title>Delete Scheduled Report</Modal.Title>
        </Modal.Header>
        <div style={{ marginLeft: 24, marginBottom: 10 }}>
          <div>
            <div
              style={{
                color: "#6d758e",
                fontSize: 14,
                fontFamily: "Open Sans",
                opacity: "70%",
              }}
            >
              Report Name
            </div>
            <div>
              <Label16>{this.state.DeleteReportName}</Label16>
            </div>
          </div>
        </div>
        <Modal.Body>
          This will permanentely delete the scheduled report. Do you want to
          proceed?
        </Modal.Body>

        <div className="divRow" style={{ marginLeft: 24 }}>
          <Button
            style={{
              marginBottom: 20,
              width: 100,
              height: 40,
              marginTop: 20,
              marginRight: 10,
            }}
            className={"primaryBtnAdd"}
            onClick={this.OnDeleteSchedule}
          >
            YES
          </Button>
          <Button
            className="secondaryBtn"
            style={{
              marginBottom: 20,
              width: 100,
              height: 40,
              marginTop: 20,
              fontSize: 14,
              color: "#402ca8",
            }}
            onClick={this.onHideCustomModal}
          >
            NO
          </Button>
        </div>
      </Modal>
    );
  }

  render() {
    return (
      <div style={{ marginTop: 20, marginBottom: 51, marginRight: 32 }}>
        <div className={this.state.showHistory ? "ShowHistory" : ""}>
          {this.state.showHistory
            ? this.renderHistoryDetails()
            : this.renderCustomReports()}

          {this.renderDeleteCustomView()}
        </div>
        <SnackMsg
          show={this.state.showSnack}
          msg={this.state.snackMsg}
          onClose={this.onCloseSnack}
        />
      </div>
    );
  }
}

export default ReportsHistory;
